<template>
    <v-simple-table>
        <template #default>
            <tbody>
                <tr v-for="requiredField in requiredFields(qualification)" :key="requiredField">
                    <td>{{ title(requiredField) }}</td>
                    <td>
                        {{ parse(requiredField) }}
                    </td>
                </tr>
            </tbody>
        </template>
    </v-simple-table>
</template>

<script>
import numeral from 'numeral';

const numericFields = {
    total_score: '0.0',
    d_score: '0.0',
};

export default {
    name: 'QualificationTable',

    props: {
        qualification: {
            type: Object,
            required: true,
        },
    },

    data: () => ({}),

    methods: {
        requiredFields(qualification) {
            const consideredFields = ['event', 'gender', 'level', 'total_score', 'd_score'];

            return consideredFields.filter(field => qualification[field] !== null);
        },

        parse(field) {
            if (field === 'event') {
                return { tra: 'Trampoline', dmt: 'Double-Mini', tum: 'Tumbling' }[this.qualification[field]];
            }

            if (Object.keys(numericFields).includes(field)) {
                return numeral(this.qualification[field]).format(numericFields[field]);
            }

            return this.qualification[field];
        },

        title(field) {
            return {
                year_from: 'Year From',
                year_to: 'Year To',
                event: 'Event',
                gender: 'Gender',
                level: 'Level',
                total_score: 'Total Score',
                d_score: 'Difficulty Score',
                notes: 'Notes',
            }[field];
        },
    },
};
</script>
